import React from 'react';
import { UploadCloudIcon, SearchIcon, FileTextIcon, CheckCircleIcon, ClockIcon, MailIcon, DownloadIcon } from 'lucide-react';
export function CertificateModule({
  role
}: {
  role: string;
}) {
  const vaults = [{
    id: 'SKY-2026-001',
    customer: 'Adaeze Okonkwo',
    product: 'Future Scholar Fund',
    underwriter: 'Leadway',
    tempCert: 'Generated',
    finalCert: 'Uploaded',
    date: '2026-03-10'
  }, {
    id: 'SKY-2026-002',
    customer: 'Adaeze Okonkwo',
    product: 'AutoGuard',
    underwriter: 'AXA Mansard',
    tempCert: 'Generated',
    finalCert: 'Uploaded',
    date: '2026-03-12'
  }, {
    id: 'SKY-2026-003',
    customer: 'Adaeze Okonkwo',
    product: 'TravelGuard',
    underwriter: 'Cornerstone',
    tempCert: 'Generated',
    finalCert: 'Pending',
    date: '2026-03-14'
  }, {
    id: 'SKY-2026-004',
    customer: 'Chidi Eze',
    product: 'Income Shield',
    underwriter: 'Anchor',
    tempCert: 'Generated',
    finalCert: 'Pending',
    date: '2026-03-14'
  }];
  return <div className="space-y-6" data-id="element-182">
      <div className="flex justify-between items-center" data-id="element-183">
        <div data-id="element-184">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-185">
            Certificate Management
          </h2>
          <p className="text-sm text-gray-500" data-id="element-186">
            Manage user document vaults and final underwriter certificates.
          </p>
        </div>
        {(role === 'Super Admin' || role === 'Ops Manager') && <button className="bg-[#0D3B3B] text-white px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-[#092D2D] transition-colors" data-id="element-187">
            <UploadCloudIcon className="w-4 h-4" data-id="element-188" /> Bulk Upload
          </button>}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-189">
        <div className="p-4 border-b border-gray-100" data-id="element-190">
          <div className="relative w-full max-w-md" data-id="element-191">
            <SearchIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-192" />
            <input type="text" placeholder="Search Document Vaults..." className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D]" data-id="element-193" />
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-194">
          <table className="w-full text-left" data-id="element-195">
            <thead data-id="element-196">
              <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-197">
                <th className="px-6 py-4" data-id="element-198">Plan ID & Customer</th>
                <th className="px-6 py-4" data-id="element-199">Product</th>
                <th className="px-6 py-4" data-id="element-200">Temp Certificate</th>
                <th className="px-6 py-4" data-id="element-201">Final Certificate</th>
                <th className="px-6 py-4" data-id="element-202">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-203">
              {vaults.map(vault => <tr key={vault.id} className="hover:bg-gray-50" data-id="element-204">
                  <td className="px-6 py-4" data-id="element-205">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-206">
                      {vault.id}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-207">
                      {vault.customer}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-208">
                    <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-209">
                      {vault.product}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-210">
                      {vault.underwriter}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-211">
                    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-100 text-emerald-700" data-id="element-212">
                      <CheckCircleIcon className="w-3.5 h-3.5" data-id="element-213" /> Generated
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-214">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-bold ${vault.finalCert === 'Uploaded' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-215">
                      {vault.finalCert === 'Uploaded' ? <CheckCircleIcon className="w-3.5 h-3.5" data-id="element-216" /> : <ClockIcon className="w-3.5 h-3.5" data-id="element-217" />}
                      {vault.finalCert}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-218">
                    <div className="flex items-center gap-2" data-id="element-219">
                      <button title="View Temp Cert" className="p-2 text-gray-400 hover:text-[#0D3B3B] bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors border border-gray-200" data-id="element-220">
                        <FileTextIcon className="w-4 h-4" data-id="element-221" />
                      </button>
                      <button title="Re-send Email" className="p-2 text-gray-400 hover:text-[#0D3B3B] bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors border border-gray-200" data-id="element-222">
                        <MailIcon className="w-4 h-4" data-id="element-223" />
                      </button>
                      {vault.finalCert === 'Pending' && (role === 'Super Admin' || role === 'Ops Manager') && <button title="Upload Final Cert" className="p-2 text-emerald-600 hover:text-emerald-700 bg-emerald-50 hover:bg-emerald-100 rounded-lg transition-colors border border-emerald-100" data-id="element-224">
                            <UploadCloudIcon className="w-4 h-4" data-id="element-225" />
                          </button>}
                      {vault.finalCert === 'Uploaded' && <button title="Download Final Cert" className="p-2 text-[#2BA89D] hover:text-[#0D3B3B] bg-teal-50 hover:bg-teal-100 rounded-lg transition-colors border border-teal-100" data-id="element-226">
                          <DownloadIcon className="w-4 h-4" data-id="element-227" />
                        </button>}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}